import {Env} from '@/helpers/Env'
import {Request} from 'simpli-web-sdk'
import {AxiosRequestConfig} from 'axios'

/**
 *  Só usar esse request se precisar pegar
 *  informações do itrack-chile-api
 */
export class InternationalRequest {
  /**
   * O internationalPath serve para corrigir e redirecionar os requests
   * para a API do ITrack Chile. No projeto, o padrão do env é a url
   * da api é terminar com '/' e o padrão é passar o path iniciado com
   * uma '/'. Essa função corrige o problema da request ficar com '//' e
   * se por algum acaso um deles estiver sem '/', ele irá corrigir
   *
   * @param path -> path to itrack-api-chile
   *
   * Exs:
   *  - path: '/info'
   *    Env.API_INTERNATIONAL_URL: http://localhost:8080/ItrackApiChile/api/
   *    return http://localhost:8080/ItrackApiChile/api/info
   *
   *  - path: '/panel-user'
   *    Env.API_INTERNATIONAL_URL: https://api.beta.chile.itrackbrasil.com.br/api
   *    return 'https://api.beta.chile.itrackbrasil.com.br/api/panel-user'
   */
  private static internationalPath = (path: string): string => {
    const internationalUrl = Env.API_INTERNATIONAL_URL
    if (internationalUrl.endsWith('/') && path.startsWith('/')) {
      return internationalUrl.substring(0, internationalUrl.length - 1) + path
    } else if (internationalUrl.endsWith('/') || path.startsWith('/')) {
      return internationalUrl + path
    } else {
      return internationalUrl + '/' + path
    }
  }

  static get(path: string, axiosConfig?: AxiosRequestConfig): Request {
    return Request.get(this.internationalPath(path), axiosConfig)
  }

  static post(
    path: string,
    data?: any,
    axiosConfig?: AxiosRequestConfig
  ): Request {
    return Request.post(this.internationalPath(path), data, axiosConfig)
  }

  static delete(path: string, axiosConfig?: AxiosRequestConfig): Request {
    return Request.delete(this.internationalPath(path), axiosConfig)
  }
}
